import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
import { DEFAULT_TOAST_DURATION } from "@kg-pos/common";
import { CustomerResponse, UpdateCustomerInput } from "__generated__/graphql";
import { RequireField } from "components/atoms/require-field";
import React, { useMemo } from "react";
import { useForm } from "react-hook-form";

type CustomerFormProps = {
  submit: (input: UpdateCustomerInput) => Promise<void>;
  backToTable: () => void;
  data?: CustomerResponse;
};

export const CustomerForm: React.VFC<CustomerFormProps> = ({ backToTable, submit, data }) => {
  const toast = useToast();
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      name: data?.name,
    },
  });
  const isEdit = useMemo((): boolean => {
    return !!data;
  }, [data]);

  const onSubmit = async (input: UpdateCustomerInput): Promise<void> => {
    await submit(input);
    toast({
      title: isEdit ? `${input.name}を編集しました。` : `${input.name}を新規作成しました。`,
      status: "success",
      duration: DEFAULT_TOAST_DURATION,
      isClosable: true,
    });

    backToTable();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="name" isInvalid={!!errors.name} isRequired maxW="400px">
        <FormLabel>
          名前
          <RequireField />
        </FormLabel>
        <Input
          id="name"
          placeholder="名前を入力してください。"
          {...register("name", {
            required: "名前が必要です。",
            maxLength: {
              value: 100,
              message: "100文字以下で入力してください。",
            },
          })}
        />
        <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
      </FormControl>
      <Button mt={8} colorScheme="blue" isLoading={isSubmitting} type="submit">
        {isEdit ? "編集する" : "登録する"}
      </Button>
    </form>
  );
};
